import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function TrainingIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Vector" stroke="#000000" fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M6.48182 3.09494C5.23532 1.72325 3.56264 0.812017 1.73419 0.508553 1.20897 0.434172 0.780579 0.860149 0.724439 1.38545c-0.297782 2.78634 -0.300711 4.34398 0 7.13029 -0.002656 0.43794 0.353031 0.83758 0.788321 0.88575 1.02656 0.13923 2.00913 0.47038 2.89982 0.96831"
          strokeWidth="1"></path>
    <path id="Vector_2" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round" d="M6.4823 4.71255V3.09497"
          strokeWidth="1"></path>
    <path id="Vector_3" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M12.2392 8.51578c0.3477 -2.78433 0.3671 -4.34582 0 -7.13029 -0.044 -0.33384 -0.4845 -0.951271 -1.0098 -0.87689 -1.82841 0.303464 -3.50109 1.2147 -4.74759 2.58639"
          strokeWidth="1"></path>
    <path id="Vector 1302" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M13.4899 13.5c0.1602 -1.9367 -1.6154 -3.2158 -3.70427 -3.2158l0 -2.42934c0 -0.63932 -0.51827 -1.15759 -1.15759 -1.15759 -0.63932 0 -1.15759 0.51827 -1.15759 1.15759l0 3.79304 -0.46343 0.1986c-0.71193 0.3051 -1.10272 0.9711 -1.12213 1.6535"
          strokeWidth="1"></path>
  </SvgIcon>
}
